// Copyright (c) Hamilton Manufacturing Corp.
import { useEffect, useState } from 'react';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Modal from '../../_common/Modal';
import Card from '../Card';
import Cart from '../../_common/Cart';
import Col from '../../_common/form/Col';
import { generateId } from '../../_common/api/utility';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Button from '../../_common/form/Button';
import { HamQuest } from '../../../App';
import TimeBank from '../TimeBank';
import RequireFeature, { Features } from '../../_common/RequireFeature';

const BuyTime = ({ ...props }) => {
    const {
        state: {
            active_user
        },
    } = useGlobalState();

    const [giftCards, setGiftCards] = useState([]);

    useEffect(() => {
        HamQuest.get(QuestRoute.products.time)
            .then((res) => {
                setGiftCards(res)
            })
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to get Time Offers',
                    body: 'Sorry, something went wrong. Please try again.'
                })
            })
    }, [])

    return (
        <RequireFeature requiredFeatures={Features.TimeProducts}>
            <Col>
                {(active_user.account && active_user.account.value && active_user.account.value.timeBanks.length > 0) ? 
                <Card title='Time Bank' icon='clock' collapsible>
                    <TimeBank banks={active_user.account.value.timeBanks} />
                </Card>
                : null}

                {giftCards
                    .sort((a, b) => b.price - a.price)
                    .map((e, i) => (
                        <Card key={`${i}-itemCard`} title={e.name}>
                            <span>Price: ${e.price}</span>
                            {e.value && <span>You get {e.value} Minutes of {e.productType === "VacTime" ? "Vacuum" : e.productType === "BayTime" ? "Bay" : "" } time.</span>}
                            {e.details?.map(e => <p key={generateId()}>{e}</p>)}
                            {active_user.isLoggedIn &&
                                <>
                                    <Button onClick={() => Cart.BuyNow(e)}>{'Buy Now!'}</Button>
                                </>
                            }
                        </Card>
                    ))
                }
            </Col>
        </RequireFeature>
    );
}

export default BuyTime;